export default __webpack_public_path__ + "static/media/9.ab0b9f86.svg";